export const projects = [
  {
    title: "Blogr",
    subtitle: "React",
    description:
      "Introducing Blogr, a modern publishing platform and editor that revolutionizes the way you create and share content. Empowering writers and bloggers with a clean and intuitive interface.",
    image: "./blogr.png",
    link: "https://ayoola-blogr-page.netlify.app",
  },
  {
    title: "Easybank",
    subtitle: "React",
    description:
    "Introducing Easy Bank a financial management platform built with cutting-edge technologies for a seamless banking experience Designed to simplify personal finances with a user-friendly interface",
    image: "./easybank.png",
    link: "https://easybank-ayoolaogun.netlify.app",
  },
  {
    title: "Loopstudios",
    subtitle: "React",
    description:
      "Introducing LopStudios, a leader in interactive VR technology that creates immersive experiences. Revolutionizing the way people engage with digital content.",
    image: "./loopstudios.png",
    link: "https://ayoola-ogun-loopreact.netlify.app",
  },
  {
    title: "My personal portfolio",
    subtitle: "React-portfolo",
    description:
      "Introducing my portfolio project, built with React and Tailwind CSS for a dynamic user experience   Showcasing my skills and achievements as a developer",
    image: "./portfolio.png",
    link: "",
  },
];


export const skills = [
  "JavaScript",
  "React",
  "Material UI",
  "Git",
  "HTML,Css",

];



// WEBPACK FOOTER //
// ./src/data.js